import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { FormAction } from '../../enums/form-action.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'formAction',
  standalone: false
})
export class FormActionPipe implements PipeTransform {
  public transform(value: FormAction): string {
    return getFormAction(value);
  }
}

export function getFormAction(value: FormAction): string {
  switch (value) {
    case FormAction.None:
      return 'None';
    case FormAction.EndOfPhase:
      return 'End Phase';
    case FormAction.EndOfProgram:
      return 'End Program';
    default:
      throw new Error(`Unsupported value for FormAction: ${value}.`);
  }
}

export function getFormActionList(): IdName[] {
  return enumToList(FormAction, getFormAction);
}

export function getPpFormActionList(): IdName[] {
  return getFormActionList().filter((x) => x.id !== FormAction.EndOfPhase);
}
